import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore.js';
import { Permission } from '@k-ucap/shared';

export const AccessDeniedPage = ({ requiredPermission }: { requiredPermission?: Permission }) => {
  const navigate = useNavigate();
  const userProfile = useAuthStore((s) => s.userProfile);
  const globalRole = useAuthStore((s) => s.globalRole);
  const selectedProject = useAuthStore((s) => s.selectedProject);

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" color="error">
        403 접근 불가
      </Typography>
      <Typography variant="body1">
        현재 사용자: {userProfile?.displayName ?? '미인증'} ({globalRole})
      </Typography>
      <Typography variant="body2" color="text.secondary">
        현재 프로젝트: {selectedProject?.name ?? '미선택'}
      </Typography>
      {requiredPermission && (
        <Typography variant="body2" color="text.secondary">
          필요 권한: {requiredPermission}
        </Typography>
      )}
      <Button variant="contained" onClick={() => navigate('/dashboard')}>
        Dashboard로 이동
      </Button>
    </Box>
  );
};
